import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/_core/composables/useAuthStore';
//import { useToasts } from '@/_core/composables/useToasts';

const Layout = () => import('./_shared/layout.vue')

const Index = () => import('./views/index/Index.vue')

const BookingsAdd = () => import('./views/bookings/add.vue')
//const BookingsAddFromPackage = () => import('./views/bookings/addFromPackage.vue')
const BookingsEdit = () => import('./views/bookings/edit.vue')
const BookingsIndex = () => import('./views/bookings/index.vue')
const BookingsView = () => import('./views/bookings/view.vue')

const DivingPackagesAdd = () => import('./views/divingPackages/add.vue')
const DivingPackagesEdit = () => import('./views/divingPackages/edit.vue')
const DivingPackagesIndex = () => import('./views/divingPackages/index.vue')
const DivingPackagesView = () => import('./views/divingPackages/view.vue')

const ResourcesAdd = () => import('./views/resources/add.vue')
const ResourcesEdit = () => import('./views/resources/edit.vue')
const ResourcesIndex = () => import('./views/resources/index.vue')
const ResourcesView = () => import('./views/resources/view.vue')

const MealsAdd = () => import('./views/meals/add.vue')
const MealsEdit = () => import('./views/meals/edit.vue')
const MealsIndex = () => import('./views/meals/index.vue')
const MealsView = () => import('./views/meals/view.vue')

const RoomsAdd = () => import('./views/rooms/add.vue')
const RoomsEdit = () => import('./views/rooms/edit.vue')
const RoomsIndex = () => import('./views/rooms/index.vue')
const RoomsView = () => import('./views/rooms/view.vue')

const TransportsAdd = () => import('./views/transports/add.vue')
const TransportsEdit = () => import('./views/transports/edit.vue')
const TransportsIndex = () => import('./views/transports/index.vue')
const TransportsView = () => import('./views/transports/view.vue')

const UsersAdd = () => import('./views/users/add.vue')
const UsersEdit = () => import('./views/users/edit.vue')
const UsersIndex = () => import('./views/users/index.vue')
const UsersManageRoles = () => import('./views/users/manage-roles.vue')
const UsersResetPassword = () => import('./views/users/reset-password.vue')
const UsersView = () => import('./views/users/view.vue')

//const toasts = useToasts();

const baseUrl = '/administrators';// import.meta.env.BASE_URL;

const localRoutes = {
    name: 'Administrator',
    path: '/',
    component: Layout,
    props: false,
    meta: {
        requiresAuth: true,
        roles: ['Administrator']
    },
    children: [
        { path: '', name: 'Index', component: Index },

        {
            path: 'bookings',
            children: [
                { path: 'add', name: 'BookingsAdd', component: BookingsAdd },
                //{ path: 'add-from-package', name: 'BookingsAddFromPackage', component: BookingsAddFromPackage },
                { path: 'edit/:id', name: 'BookingsEdit', component: BookingsEdit, props: true },
                { path: '', name: 'BookingsIndex', component: BookingsIndex },
                { path: 'view/:id', name: 'BookingsView', component: BookingsView, props: true },
            ]
        },

        {
            path: 'diving-packages',
            children: [
                { path: 'add', name: 'DivingPackagesAdd', component: DivingPackagesAdd },
                { path: 'edit/:id', name: 'DivingPackagesEdit', component: DivingPackagesEdit, props: true },
                { path: '', name: 'DivingPackagesIndex', component: DivingPackagesIndex },
                { path: 'view/:id', name: 'DivingPackagesView', component: DivingPackagesView, props: true },
            ]
        },

        {
            path: 'meals',
            children: [
                { path: 'add', name: 'MealsAdd', component: MealsAdd },
                { path: 'edit/:id', name: 'MealsEdit', component: MealsEdit, props: true },
                { path: '', name: 'MealsIndex', component: MealsIndex },
                { path: 'view/:id', name: 'MealsView', component: MealsView, props: true },
            ]
        },

        {
            path: 'rooms',
            children: [
                { path: 'add', name: 'RoomsAdd', component: RoomsAdd },
                { path: 'edit/:id', name: 'RoomsEdit', component: RoomsEdit, props: true },
                { path: '', name: 'RoomsIndex', component: RoomsIndex },
                { path: 'view/:id', name: 'RoomsView', component: RoomsView, props: true },
            ]
        },

        {
            path: 'transports',
            children: [
                { path: 'add', name: 'TransportsAdd', component: TransportsAdd },
                { path: 'edit/:id', name: 'TransportsEdit', component: TransportsEdit, props: true },
                { path: '', name: 'TransportsIndex', component: TransportsIndex },
                { path: 'view/:id', name: 'TransportsView', component: TransportsView, props: true },
            ]
        },

        {
            path: 'users',
            children: [
                { path: 'add', name: 'UsersAdd', component: UsersAdd },
                { path: 'edit/:id', name: 'UsersEdit', UsersEdit, props: true },
                { path: '', name: 'UsersIndex', component: UsersIndex },
                { path: 'manage-roles/:id', name: 'UsersManageRoles', component: UsersManageRoles, props: true, },
                { path: 'reset-password/:id', name: 'UsersResetPassword', component: UsersResetPassword, props: true, },
                { path: 'view/:id', name: 'UsersView', component: UsersView, props: true },
            ]
        },
    ]
};

export const router = createRouter({
    history: createWebHistory(baseUrl),
    linkActiveClass: 'active',
    routes: [
        { ...localRoutes },
        // catch all redirect to home page
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

router.beforeEach(async (to) => {
    //debugger;
    //eventBus.$emit('chat:close');

    var meta = to.meta;
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/accounts/login', '/accounts/logout', '/accounts/register'];
    const authRequired = meta.requiresAuth && !publicPages.includes(to.path);
    const authStore = useAuthStore();
    const user = authStore.user;

    //debugger
    if (authRequired && !user) {
        const loginUrl = new URL(`/accounts/login`, window.location.origin)
        loginUrl.searchParams.set('returnUrl', encodeURIComponent(to.href));
        window.location.href = loginUrl.toString();
        return false;
        //authStore.returnUrl = to.fullPath;
        //return {
        //    path: '/accounts/login/',
        //    query: { returnUrl: encodeURIComponent(to.fullPath) }
        //};
    }

    var roles = to.meta.roles;

    if (roles && !user.roles.some(e => roles.includes(e))) {
        const notAuthorizedUrl = new URL(`/accounts/not-authorized`, window.location.origin)
        //alert('You are not authorized to acccess this page.')
        //debugger;
        window.location.href = notAuthorizedUrl.toString();
        return false;
        //window.location.href = loginUrl.toString();

        //return false;
        //return false;
        //return {
        //    path: '/account/login/',
        //    query: { returnUrl: encodeURIComponent(to.fullPath) }
        //};
    }
});